import { render, staticRenderFns } from "./DepositTargetDialog.vue?vue&type=template&id=8487c08e&"
import script from "./DepositTargetDialog.vue?vue&type=script&lang=js&"
export * from "./DepositTargetDialog.vue?vue&type=script&lang=js&"
import style0 from "./DepositTargetDialog.vue?vue&type=style&index=0&id=8487c08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports